import { CardProps, CardVariant } from '../../lib/types';

type BuildVariantCardPropsInput = Pick<
  CardProps,
  | 'entity'
  | 'actionRoute'
  | 'actionLabel'
  | 'variant'
  | 'maxDescriptionLength'
  | 'actionable'
  | 'withoutTheme'
  | 'styles'
> & {
  resolvedActionRoute?: string;
  defaultActionLabel: string;
};

export const buildVariantCardProps = (
  input: BuildVariantCardPropsInput,
): CardProps => {
  const {
    entity,
    actionRoute,
    actionLabel,
    variant,
    actionable,
    withoutTheme,
    resolvedActionRoute,
    defaultActionLabel,
  } = input;

  const resolvedActionLabel = actionLabel ?? defaultActionLabel;
  const isActionable =
    actionable ?? !!(actionRoute || (resolvedActionLabel && withoutTheme));

  return {
    entity,
    variant: variant ?? CardVariant.normal,
    maxDescriptionLength: 128,
    actionable: isActionable,
    actionRoute: actionRoute ?? resolvedActionRoute,
    actionLabel: resolvedActionLabel,
    withoutTheme,
    styles: {
      icon: {
        opacity: isActionable ? 0.5 : 1,
      },
    },
  };
};
